module.exports = __webpack_public_path__ + "static/media/md-contact.493ed010.svg";